import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-content" }
const _hoisted_2 = { class: "width500px" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { class: "shell" }
const _hoisted_5 = { class: "search-container" }
const _hoisted_6 = { class: "search-form-item" }
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "search-form-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_add_template = _resolveComponent("add-template")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_list = _resolveComponent("list")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_add_template, { onChoose: _ctx.choose }, null, 8, ["onChoose"]),
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.addform,
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextTitle,
              prop: "MessageTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.addform.MessageTitle,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.addform.MessageTitle = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextMessageContent,
              prop: "Message"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  rows: 5,
                  modelValue: _ctx.addform.Message,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.addform.Message = $event)),
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextSendTo,
            prop: "HaveDevice"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_el_radio, {
                modelValue: _ctx.addform.ClientType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.addform.ClientType = $event)),
                label: "0"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelMessageBoxBoth), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_radio, {
                modelValue: _ctx.addform.ClientType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.addform.ClientType = $event)),
                label: "1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelMessageBoxIndoor), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_radio, {
                modelValue: _ctx.addform.ClientType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.addform.ClientType = $event)),
                label: "2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelMessageBoxApp), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.ChangeWordList.PMSetAccessBuildOrDepartment), 1),
            (_ctx.projectType==='community')
              ? (_openBlock(), _createBlock(_component_cus_select, {
                  key: 0,
                  modelValue: _ctx.listRequestData.param.Build,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.listRequestData.param.Build = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_cus_option, {
                      label: _ctx.$wordList.SelectAll,
                      value: "all"
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item.key,
                        value: item.key,
                        label: item.value
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.projectType==='office')
              ? (_openBlock(), _createBlock(_component_cus_select, {
                  key: 1,
                  modelValue: _ctx.listRequestData.param.Department,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.listRequestData.param.Department = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_cus_option, {
                      label: _ctx.$wordList.SelectAll,
                      value: "all"
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item.key,
                        value: item.key,
                        label: item.value
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.listRequestData.param.Key,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.listRequestData.param.Key = $event)),
              placeholder: _ctx.$wordList.ProperAllTextUEN
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createVNode(_component_cus_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateList++))
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_list, {
          headers: _ctx.header,
          "request-data": _ctx.listRequestData,
          update: _ctx.updateList,
          keyOfCheck: "Account",
          action: false,
          showCheck: "OnlyCheck",
          onMultipleSelect: _ctx.selectDevice,
          onGetTotal: _ctx.getTotal
        }, null, 8, ["headers", "request-data", "update", "onMultipleSelect", "onGetTotal"]),
        _createVNode(_component_cus_button, {
          type: "blue",
          class: "margin-top80px",
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextSend), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}